import axios from "axios"
import { url } from "../helper"

export const searchContent = async (
	query: string,
	index: string,
	filters: string[] = [], // f[] values like ['category_id:11']
	locale: string,
	page = 0
) => {
	const response = await axios.get(`${url}/api/search/${index}`, {
		params: {
			q: query,
			...filters.reduce((acc, val, i) => {
				acc[`f[${i}]`] = val
				return acc
			}, {} as Record<string, string>),
			"filter[langcode]": locale,
			page,
			jsonapi_include: 1,
			include: "field_trailer_file,field_image,field_type,field_cast,field_features",
		},
	})
	return response.data
}
